var map = {
	"./img_form2_en.png": "4768",
	"./img_form2_ja.png": "451f",
	"./img_form2_ko.png": "0e95",
	"./img_form2_zh.png": "abad",
	"./img_form2_zh_cn.png": "7bd3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "78e6";